export default class Module {

    constructor() {
        
        this.title = '' // String
        this.training_id = '' // Integer
        this.aws_s3_base_url = '';
        this.files = []
    }
}